<template>
  <asc-tooltip
    :tooltip="tooltip"
    bottom
    :tooltip-length="0"
    :class="[disabled ? 'asc-tab-tooltip--disabled' : '', 'asc-tab']"
  >
    <v-tab
      :ripple="false"
      :disabled="disabled"
      :class="[vertical ? 'asc-tab-title--vertical' : '']"
      :to="to"
      :href="getTabName"
    >
      <div class="asc-tab--title">
        <template v-if="icon && !iconRight">
          <v-icon
            class="asc-tab-title--info-icon"
            size="18"
            @click="tabIconAction ? tabIconAction : null"
            >{{ icon }}</v-icon
          >
        </template>
        <span>{{ title }}</span>
        <template v-if="icon && iconRight">
          <v-icon
            class="asc-tab-title--info-icon"
            size="18"
            @click="handleTabIconClick"
            >{{ icon }}</v-icon
          >
        </template>
        <template v-if="error">
          <v-icon
            class="asc-tab-title--error-icon"
            :color="getErrorIconColor"
            size="18"
            @click="handleTabIconClick"
            >mdi-alert-circle</v-icon
          >
        </template>
      </div>
    </v-tab>
  </asc-tooltip>
</template>

<script>
import AscTooltip from '@/components/atoms/AscTooltip'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscTabTitle',

  components: {
    AscTooltip,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    iconRight: {
      type: Boolean,
      default: false,
    },
    tabIconAction: {
      type: Function,
      default: () => {},
    },
    name: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    getErrorIconColor() {
      return variables.warningbase
    },
    getTabName() {
      return this.name ? `#${this.name}` : undefined
    },
  },

  methods: {
    handleTabIconClick() {
      this.$emit('iconClick')
    },
  },
}
</script>

<style lang="scss">
.asc-tab {
  .v-tab,
  .v-tabs-slider-wrapper {
    max-height: 43px;
    min-width: 80px;
  }

  .asc-tab--title {
    color: $gray-1000;
    font-size: $font-size-md;
    letter-spacing: 0.6px;
    line-height: 22px;

    &:hover {
      color: $accent-700;
    }

    .asc-tab-title--error-icon {
      margin-left: 8px;
      padding-bottom: 2px;
    }

    .asc-tab-title--info-icon {
      margin-right: 8px;
      padding-bottom: 2px;
    }
  }

  .v-tab {
    min-width: 80px;
    padding: 9px 16px 12px;
    font-weight: normal;

    &--active {
      .asc-tab--title {
        color: $accent-700;
      }
    }

    &--disabled {
      .asc-tab--title {
        opacity: 0.9;
      }
    }

    &:not(.v-tab--active) {
      opacity: 1;

      &:hover {
        color: transparent;
      }
    }
  }

  .asc-tab-tooltip--disabled {
    cursor: not-allowed;
  }

  .asc-tab-title--vertical {
    max-height: 34px;
    text-transform: none;

    &.v-tab {
      justify-content: flex-start;
      max-height: 34px;
      padding: 9px 0 9px 12px;

      .asc-tab--title {
        color: $primary-black;
        font-weight: normal;
        letter-spacing: normal;
        line-height: 18px;
      }

      &:hover {
        background-color: $gray-0;
      }

      &--active {
        background-color: $primary-white;
        position: relative;
        width: 200px;

        &::before {
          content: '';
          background-color: $accent-500;
          height: 34px;
          position: absolute;
          left: 0;
          width: 5px;
          opacity: 1 !important;
        }
      }
    }
  }
}
</style>
